import { ProductCategorySlug, ProductSlug } from "@api";
import { europeanLanderSlugs } from "./localizations";

export interface EuStockedProductGroup {
  categorySlug: ProductCategorySlug;
  titleKey: europeanLanderSlugs;
  bodyKey: europeanLanderSlugs;
  slugs: ProductSlug[];
}

/**
 * The EU lander borrows the /products page's three category headings, in the same words, over
 * the subset of the lineup that is stocked in Prague. Both the group order and the order of
 * tiles inside a group are curated here rather than taken from the CMS `order`, so the section
 * keeps the arrangement the client signed off on: the Singular card that `EUStockedProducts`
 * renders ahead of these groups, then all-in-ones, cartridges, batteries.
 */
export const euStockedProductGroups: EuStockedProductGroup[] = [
  {
    categorySlug: ProductCategorySlug.AllInOnes,
    titleKey: "category.all-in-ones.title",
    bodyKey: "category.all-in-ones.body",
    slugs: [
      ProductSlug.AxilMiniAir,
      ProductSlug.AxilMiniPro,
      ProductSlug.Axil,
      ProductSlug.Leaf,
    ],
  },
  {
    categorySlug: ProductCategorySlug.Cartridges,
    titleKey: "category.cartridges.title",
    bodyKey: "category.cartridges.body",
    slugs: [ProductSlug.EzClickCeramicPro, ProductSlug.EzClickGlass],
  },
  {
    categorySlug: ProductCategorySlug.Batteries,
    titleKey: "category.batteries.title",
    bodyKey: "category.batteries.body",
    slugs: [ProductSlug.RootXL, ProductSlug.ActiveSprout],
  },
];

export const euStockedProductsSlugs = euStockedProductGroups.flatMap(
  (group) => group.slugs
);
